import { PermissionsConjunction } from 'frontend-container/components/Menu/authorization/types';
import { MenuElement } from 'frontend-container/components/Menu/types';

import { customerPermissionKeys } from '@ac/library-api';
import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

const identityPermissions = customerPermissionKeys.identity;

export const systemUsersMenu: MenuElement = {
  translation: 'MENU.SYSTEM_USERS.TITLE',
  icon: IconName.profile,
  id: 'menu-users',
  items: [
    {
      link: `${acConfig.newFrontendUrls.configurationv2}/system-users`,
      translation: 'MENU.SYSTEM_USERS.ITEMS.LIST',
      permissionsConfiguration: {
        permissions: [identityPermissions.viewUsers],
        permissionsConjunction: PermissionsConjunction.And,
      },
    },
    {
      link: `${acConfig.newFrontendUrls.configuration}/system-roles`,
      translation: 'MENU.SYSTEM_USERS.ITEMS.SYSTEM_ROLES',
      permissionsConfiguration: {
        permissions: [identityPermissions.viewRoles],
        permissionsConjunction: PermissionsConjunction.And,
      },
    },
  ],
};
